import React, { useEffect, useRef, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { updateDetails } from 'nursd-dashboard/api/agencyTable';
import { getAllFacilityOrgList } from 'nursd-dashboard/api/organizationTable';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { socket } from 'nursd-dashboard/api/socket';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Flex from 'components/common/Flex';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { licenseTypes } from 'nursd-dashboard/data/defaultData';
import {
  formatPhoneNumber,
  removeFormatting
} from 'nursd-dashboard/utils/function';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

function Update_Agency({ data, authToken, getAgency, setShow }) {
  const [newAgency, setNewAgency] = useState({
    email: data?.emailId,
    firstName: data?.firstName,
    lastName: data?.lastName,
    password: data?.password,
    phoneNumber: data?.phoneNumber,
    agencyVerified: data?.agencyVerified,
    emailVerified: data?.emailVerified,
    agencyLoginControl: data?.agencyLoginControl,
    agencyAppAccessControl: data?.agencyAppAccessControl,
    organization: data?.organization,
    location_id: data?.location_id,
    fullAddress: data?.fullAddress,
    latitude: data?.latitude,
    longitude: data?.longitude,
    agencyName: data?.additionalFields[0]?.agencyName,
    faxNumber: data?.additionalFields[0]?.faxNumber,
    comments: data?.additionalFields[0]?.comments
  });

  const [valueLicense, setValueLicense] = useState(
    data?.additionalFields[0]?.licenseTypes
  );
  const animatedComponents = makeAnimated();

  const handleInputChangeNewData = event => {
    setNewAgency(prevState => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const searchInput = useRef(null);

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleInputChangeNewData({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'city',
        value: extractAddress(place)?.locality
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'state',
        value: extractAddress(place)?.administrative_area_level_1
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'zipCode',
        value: extractAddress(place)?.postal_code
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateAgency = async () => {
    setLoading(true);
    try {
      await updateDetails(authToken, data?.id, {
        firstName: newAgency?.firstName,
        lastName: newAgency?.lastName,
        email: newAgency.email,
        phoneNumber: removeFormatting(newAgency.phoneNumber),
        password: newAgency.password,
        agencyLoginControl: newAgency.agencyLoginControl,
        agencyAppAccessControl: newAgency.agencyAppAccessControl,
        fullAddress: newAgency.fullAddress,
        latitude: newAgency.latitude.toString(),
        longitude: newAgency.longitude.toString(),
        additionalFields: [
          {
            licenseTypes: valueLicense,
            agencyName: newAgency.agencyName,
            faxNumber: newAgency.faxNumber,
            comments: newAgency.comments
          }
        ]
      }).then(res => {
        if (data?.agencyLoginControl !== newAgency.agencyLoginControl) {
          // alert(newAgency.agencyLoginControl ? 'Activated' : 'Deactivated');
          getAllFacilityOrgList(
            authToken,
            data?.organization,
            data?.location_id
          )
            .then(async facilitiesData => {
              for (const facility of facilitiesData) {
                if (Number(facility?.id) !== Number(res?.id)) {
                  try {
                    await postFacilityNotification(
                      authToken,
                      facility?.id,
                      '',
                      `Agency ${
                        res?.firstName + ' ' + res?.lastName
                      } has been ${
                        newAgency.agencyLoginControl
                          ? 'Activated'
                          : 'Deactivated'
                      }`,
                      `Agency ${
                        res?.firstName + ' ' + res?.lastName
                      } has been ${
                        newAgency.agencyLoginControl
                          ? 'Activated'
                          : 'Deactivated'
                      } by Admin.`,
                      'NotificationScreen',
                      {
                        id: ''
                      },
                      false,
                      false,
                      'green',
                      ''
                    );
                    socket?.emit('tableNotificationInsert', {
                      table: 'FacilityNotificationTable',
                      id: facility?.id
                    });
                    if (facility?.mobileId) {
                      sendNotification(authToken, {
                        expoPushToken: facility?.mobileId,
                        title: `Agency ${
                          res?.firstName + ' ' + res?.lastName
                        } has been ${
                          newAgency.agencyLoginControl
                            ? 'Activated'
                            : 'Deactivated'
                        }`,
                        body: `Agency ${
                          res?.firstName + ' ' + res?.lastName
                        } has been ${
                          newAgency.agencyLoginControl
                            ? 'Activated'
                            : 'Deactivated'
                        } by Admin.`,
                        data: { screen: 'NotificationScreen' }
                      });
                    }
                  } catch (error) {
                    console.error('Error fetching facility detail:', error);
                  }
                }
              }
            })
            .catch(error => console.error('Fetching facility:', error));
        }
        socket?.emit('activateDeactivate', {
          table: 'AgencyTable',
          id: res?.id
        });
        toast.success(
          res?.firstName +
            ' ' +
            res?.lastName +
            ' record updated successfully.',
          {
            theme: 'colored'
          }
        );
        setLoading(false);
        setNewAgency({
          email: '',
          firstName: '',
          lastName: '',
          password: '',
          phoneNumber: '',
          organization: '',
          location_id: '',
          agencyVerified: false,
          emailVerified: false,
          agencyLoginControl: false,
          agencyAppAccessControl: false
        });
        getAgency();
        setShow(false);
      });
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior

    const form = event.currentTarget;
    // console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    updateAgency();
  };

  return (
    <>
      <Form
        noValidate
        validated={validated}
        onSubmit={loading ? null : handleSubmit}
      >
        <Row className="mb-3">
          <Form.Group as={Col} md="4" controlId="FirstName">
            <Form.Label>First name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="First name"
              name="firstName"
              value={newAgency.firstName}
              onChange={handleInputChangeNewData}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please enter a first name.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="LastName">
            <Form.Label>Last name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Last name"
              name="lastName"
              value={newAgency.lastName}
              onChange={handleInputChangeNewData}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please enter a last name.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="Email">
            <Form.Label>Email</Form.Label>
            <InputGroup hasValidation>
              <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Email"
                aria-describedby="inputGroupPrepend"
                required
                name="email"
                value={newAgency.email}
                onChange={handleInputChangeNewData}
                disabled
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a email.
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} md="4" controlId="PhoneNumber">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Phone Number"
              name="phoneNumber"
              value={formatPhoneNumber(newAgency.phoneNumber)}
              onChange={handleInputChangeNewData}
              // pattern="[0-9]*"
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please enter a phone number.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="Password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Password"
              name="password"
              value={newAgency.password}
              onChange={handleInputChangeNewData}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please enter a password.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="checkbox">
            <Form.Label></Form.Label>
            <Form.Check
              type="checkbox"
              id="defaultCheckbox"
              label="Deactivate"
              className="mt-2"
              checked={!newAgency.agencyLoginControl}
              onChange={() =>
                handleInputChangeNewData({
                  target: {
                    name: 'agencyLoginControl',
                    value: !newAgency.agencyLoginControl
                  }
                })
              }
            />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} md="4" controlId="FullAddress">
            <Form.Label>Full Address</Form.Label>
            <Form.Control
              required
              ref={searchInput}
              contentEditable={false}
              type="text"
              placeholder="Full Address"
              value={newAgency.fullAddress}
              name="fullAddress"
              onChange={handleInputChangeNewData}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please choose a full address.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" className="mb-2" controlId="License">
            <Form.Label className="fs-9">Select License Type</Form.Label>
            <Select
              closeMenuOnSelect={false}
              options={licenseTypes}
              placeholder="Select..."
              isMulti
              classNamePrefix="react-select"
              value={valueLicense}
              onChange={value => {
                setValueLicense(value);
              }}
              components={animatedComponents}
              required
            />
          </Form.Group>
        </Row>
        <Flex>
          <Button type="submit">
            {loading
              ? 'Loading...'
              : `Update ${data?.firstName + ' ' + data?.lastName}`}
          </Button>
          <Button
            onClick={() => setShow(false)}
            variant="secondary"
            className="mx-2"
          >
            Close
          </Button>
        </Flex>
      </Form>
    </>
  );
}

Update_Agency.propTypes = {
  data: PropTypes.any,
  authToken: PropTypes.any,
  getAgency: PropTypes.any,
  setShow: PropTypes.any
};

export default Update_Agency;
